<template>
  <div>
    <div class="container" v-if="!loading">
      <div class="center">
        <img
          class="mb-4"
          style="width:200px"
          src="../assets/iSimulate-Logo.svg"
        />
        <h6>{{resultMsg}}</h6>
      </div>
      
      <small class="form-text text-muted" style="margin-top: 16px;">
        <router-link tag="span" class="small-link" to="/login">Go to login page</router-link>
      </small>
    </div>
    <div class="container" v-if="loading">
      <PleaseWait></PleaseWait>
      <div>
        Verifying your account...
      </div>
    </div>
  </div>
</template>

<script>
import userService from '../services/user.service';
import PleaseWait from '../components/PleaseWait';

export default {
  name: "EmailVerify",
  components: {
    PleaseWait
  },
  data: function() {
    return {
      loading: true,
      isError: false
    }
  },
  computed: {
    resultMsg() {
      return this.isError
        ? "Your account could not be verified. Please try again."
        : "Account Verified. Please login below."
    },
    currentDistributor() {
      return this.$store.getters.getDistributor;
    },
  },
  mounted() {
    userService.verifyEmail(this.$route.params.token, this.currentDistributor)
      .then(() => {
        this.$store.commit("setUserJustVerified", true);
        this.isError = false;
        this.$router.push("/login");
      })
      .catch((err) => this.isError = true)
      .finally(() => this.loading = false);
  }
};
</script>

<style scoped>
.container {
  margin: 40px auto;
  max-width: 340px;
}

.center {
  text-align: center;
  margin-bottom: 30px;
}

.small-link {
    cursor: pointer;
    font-weight: bold;
}
</style>
